@if(currentView === views.Home) {
  <div class="container">
    <button (click)="selectView(views.Secrets)" class="request-button">Ver Secretos</button>

    <button (click)="selectView(views.CreatingSecret)" class="request-button">Crear Secreto</button>
  </div>

  <!-- <div class="secret-searched-container">
    <div class="secret-search-information">
      <p class="text-info">Devuelve un Secreto específico (GET).</p>
      <button (click)="getSecret()">Buscar Secreto</button>
      <div class="name-input-container" >
        <input type="text" [(ngModel)]="secretNameToSearch" class="name-input" placeholder="Nombre">
        @if(secretNotFound) {
          <p class="secret-not-found">Secreto no encontrado</p>
        }
      </div>
    </div>

    <div class="secret-searched">
      <p><strong>Nombre: </strong>{{secretSearched ? secretSearched.nombre : ''}}</p>
      <p><strong>Valor: </strong>{{secretSearched ? secretSearched.valor: ''}}</p>
    </div>
  </div> -->
}

@if(currentView === views.Secrets) {
  <div class="search-container">
    <input type="text" class="search-input" [(ngModel)]="secretToSearch" (ngModelChange)="onSearchChange()" placeholder="Buscar por nombre">
    <button class="back-button button button-colors" (click)="selectView(views.Home)">Volver</button>
  </div>

  <!-- Vista de Secretos -->
  <div class="scroll-container">
    <div class="secrets-container">
      @for(secret of secrets; track secret.nombre) {
        <div class="secret" (click)="selectView(views.SecretDetails, secret)">
          <p>{{secret.nombre}}</p>
        </div>
      }
    </div>
  </div>
}

<!-- Vista de crear, editar y detalles Secreto -->
@if(currentView === views.SecretDetails ||currentView === views.EditingSecret || currentView === views.CreatingSecret) {
  <div class="info-secret-container">
    <h4>{{currentView === views.SecretDetails ? 'Detalles de' : (currentView === views.EditingSecret ? 'Editar' : 'Crear')}} Secreto</h4>

    <div class="input-container">
      <label>Nombre:</label>
      <input type="text" class="new-input" [(ngModel)]="newSecret.nombre" placeholder="Nombre de secreto"
        [readOnly]="currentView === views.SecretDetails">
    </div>

    <div class="input-container">
      <label>Valor:</label>
      <textarea type="text" class="textarea" [(ngModel)]="newSecret.valor" placeholder="Valor de secreto"
        [readOnly]="currentView === views.SecretDetails"></textarea>
    </div>

    <div class="info-buttons">
      <button class="button button-colors"
        (click)="currentView === views.EditingSecret ? selectView(views.SecretDetails) : (currentView === views.SecretDetails ? selectView(views.Secrets) : selectView(views.Home))">
        Volver
      </button>

      @if(currentView === views.SecretDetails) {
        <button class="button button-colors" (click)="deleteSecret()" [disabled]="!globalService.editing">Eliminar Secreto</button>
      }

      <button class="button button-colors"
        (click)="currentView === views.CreatingSecret ? createSecret() : (currentView === views.EditingSecret ? editSecret() : selectView(views.EditingSecret))"
        [disabled]="!globalService.editing || (newSecret.nombre.length === 0 || newSecret.valor.length === 0) || (newSecret.nombre === ' ' || newSecret.valor === ' ')">
        {{currentView === views.SecretDetails ? 'Editar': 'Confirmar'}}
      </button>
    </div>
  </div>
}